<template>
  <div class="calico-badge-page">
    Calico Badges
    <div class="container">
      <div class="div">
        <span class="badge-green">Label</span>
        <span class="badge-cyan">Label</span>
        <span class="badge-yellow">Label</span>
        <span class="badge-pink">Label</span>
        <span class="badge-orange">Label</span>
        <span class="badge-red">Label</span>
        <span class="badge-black">Label</span>
        <span class="badge-lapis">Label</span>
      </div>
      <div class="div">
        <span class="badge-green-outline">Label</span>
        <span class="badge-cyan-outline">Label</span>
        <span class="badge-yellow-outline">Label</span>
        <span class="badge-pink-outline">Label</span>
        <span class="badge-orange-outline">Label</span>
        <span class="badge-red-outline">Label</span>
        <span class="badge-black-outline">Label</span>
        <span class="badge-lapis-outline">Label</span>
        <span class="badge-gray-outline">Label</span>
      </div>
    </div>
  </div>
</template>

<script lang="js">

export default {
  name: 'CalicoBadgePage',
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
.calico-badge-page {
  .div {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .container {
    margin: 50px;
    display: flex;
    flex-direction: row;
    gap: 20px;
  }
}
</style>
